export const CHARACTER_SELECT_LEFT_MOVES_MS = [650, 2450, 5050, 8150] as const;
export const CHARACTER_SELECT_RIGHT_MOVES_MS = [1350, 3650, 6650, 9650] as const;
export const CHARACTER_SELECT_READY_MS = 11000;
export const CHARACTER_SELECT_FIGHT_MS = 13000;
export const CHARACTER_SELECT_EXPLOSION_MS = 14000;
export const VERSUS_FIGHT_MS = 9700;
export const VERSUS_EXPLOSION_MS = 10700;

export function completedSelectionMoves(elapsedMs: number, schedule: readonly number[]) {
  return schedule.filter((time) => elapsedMs >= time).length;
}
